import { Alert } from '../ui/Alert';
import { Button } from '../ui/Button';
import { TextLink } from '../ui/TextLink';
import type { IncrementSteering } from './increment-steering';

/**
 * The off-increment nudge shown below a duration field: what the firm's
 * increment is, and a one-click round-up to the next whole one.
 *
 * Rendered by both the activity wizard and the inline linked-activity editor
 * so a duration is steered identically wherever it is typed.
 */
export function IncrementSteeringAlert({
  steering,
  onRoundUp,
}: {
  steering: IncrementSteering;
  onRoundUp: () => void;
}) {
  return (
    <Alert variant="warning">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <p>
          Not a multiple of your firm&apos;s{' '}
          <TextLink to="/settings?tab=billing" tone="notice">
            {steering.incrementLabel} increment
          </TextLink>
          .
        </p>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          className="shrink-0 self-start sm:self-auto"
          onClick={onRoundUp}
        >
          Round up to {steering.roundedLabel}
        </Button>
      </div>
    </Alert>
  );
}
